const populateMegaMenuPreview = (item) => {
  const imageUrl = item.dataset.img;
  if (imageUrl) {
    const megaMenuContent = item.closest('[id^="MegaMenu-Content-"]');
    if (megaMenuContent) {
      const imageElement = megaMenuContent.querySelector(
        "#mega-menu-link-preview",
      );
      if (imageElement) {
        imageElement.src = imageUrl;
        imageElement.alt = item.dataset.imgAlt || "";
      }
    }
  }

  //check if card wrapper exists and remove hidden class
  const cardWrapper = item
    .closest('[id^="MegaMenu-Content-"]')
    .querySelector(".card-wrapper");
  if (cardWrapper) {
    cardWrapper.classList.remove("sms-hidden");
  }
};

document.querySelectorAll(".sms-mega-menu-preview").forEach((item) => {
  item.addEventListener("mouseenter", () => populateMegaMenuPreview(item));
});
